<template>
  <div id="nav">

    <router-link to="/">Home</router-link>

    <router-link to="/roster">Roster</router-link>

    <div v-if="isAuthenticated" id="dropdowns">
      <Dropdown
        :options="userguilds"
        v-model="selGuild"
        labelby="name"
        placeholder="Select Guild"/>
      <Dropdown
        :options="destinations"
        v-model="selDestination"
        labelby="name"
        placeholder="Select Destination"/>
      <Dropdown
        :options="lockouts"
        v-model="selLockout"
        labelby="name"
        placeholder="Select Lockout"/>
    </div>
    <div v-else>
    </div>

    <div>
    </div>

    <span v-if='!isAuthenticated'>
      <router-link to="/signin">Sign In</router-link>
       |
      <router-link to="/join">Register</router-link>
    </span>
    <div v-else class="logoutouter">
      <div class="logoutinner" @click="logout">
        Logout
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { mapActions, mapState } from 'vuex'
import Dropdown from '../Dropdown'
import { SELECTGUILD } from '../../store/modules/guilds'
import { SELECTDESTINATION } from '../../store/modules/destinations'
import { SELECTLOCKOUT } from '../../store/modules/lockouts'
import { FAILAUTHENTICATION } from '../../store/modules/authentication'

// import 'vue-next-select/dist/index.min.css'
import '../../css/vuenextselect.css'

export default {
  name: 'AppNavigation',
  components: {
    Dropdown,
  },
  computed: {
    userguilds () {
      let user = this.user
      return this.guilds.filter( g => user.admin ||
                                      user.guilds && user.guilds[ g['.key' ] ] )
    },
    selGuild: {
      get (       ) { return this.selectedGuild },
      set ( value ) { this.SELECTGUILD( value ) },
    },
    selDestination: {
      get (       ) { return this.selectedDestination },
      set ( value ) { this.SELECTDESTINATION( value ) },
    },
    selLockout: {
      get (       ) { return this.selectedLockout },
      set ( value ) { this.SELECTLOCKOUT( value ) },
    },
    ...mapState({
      user: state => state.authentication.user,
      isAuthenticated: state => state.authentication.isAuthenticated,
      guilds: state => state.guilds.guilds,
      selectedGuild: state => state.guilds.selectedGuild,
      destinations: state => state.destinations.destinations,
      selectedDestination: state => state.destinations.selectedDestination,
      lockouts: state => state.lockouts.lockouts,
      selectedLockout: state => state.lockouts.selectedLockout,
    }),
  },
  methods: {
    ...mapActions([
      SELECTGUILD,
      SELECTDESTINATION,
      SELECTLOCKOUT,
      FAILAUTHENTICATION,
    ]),
    logout() {
      try {
        firebase.auth().signOut()
      }
      catch ( error ) {
        this.FAILAUTHENTICATION( error )
      }
    },
  },  
}
</script>

<style scoped>
#nav {
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: var(--toolbar-bg-color);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 25px;
  z-index: 99;
  display: inline-grid;
  grid-template-columns: 80px 80px 480px auto 165px;
  align-items: center;
}

#nav a {
  font-weight: bold;
  color: rgb(142, 146, 145);
  text-decoration: none;
}

.logoutouter {
  display: flex;
  flex-direction: row-reverse;
  padding-right: 16px;
  text-align: right;
}

.logoutinner {
  font-weight: bold;
  color: rgb(142, 146, 145);
  text-align: right;
  cursor: pointer;
}

#nav a.router-link-exact-active {
  color: var(--header-font-color);
}

#dropdowns {
  display: inline-grid;
  padding-left: 10px;
  gap: 10px;
  grid-template-columns: 150px 150px 150px;
}
</style>